import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { Field } from 'redux-form';

import { Wrapper } from './SummaryField';

const ShelfList = styled.ul`
  list-style: none;
  text-align: center;
  color: ${props => props.theme.secondary};
  fill: ${props => props.theme.secondary};
  margin-top: 16px;
`;

const RenderPreview = ({ input: { value } }) => {
  const stringValue = JSON.stringify(value);
  return <span>{stringValue}</span>;
};

export const Label = styled.div`
  color: ${props => props.theme.primary}
  font-size: 16px;
`;

export const Item = styled.li`
  color: ${props => props.theme.secondary}
  font-size: 14px;
`;

const ShelvesSummaryField = ({ t, fields }) => (
  <Wrapper>
    <Label>{t('device_shelf_config.label')}</Label>
    <ShelfList>
      {fields.length > 0 ? (
        fields.map((shelfSlot, index) => (
          <Item key={index}>
            <Field name={`${shelfSlot}.shelfId`} component={RenderPreview} />:
            <Field name={`${shelfSlot}.slotId`} component={RenderPreview} />
          </Item>
        ))
      ) : (
        <Item>-</Item>
      )}
    </ShelfList>
  </Wrapper>
);

export default translate()(ShelvesSummaryField);
